import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../common/buttons/SubmitButton'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'

import './ExitModal.scss'

const ExitModal = ({ showModal, closeModal, onSubmit, saveDraftScores, event }) => {
  const { t } = useTranslation()

  const scoresSavedAt = useMemo(() => {
    const scores = JSON.parse(localStorage.getItem('draftScores'))

    return scores && scores[event.id] && scores[event.id]['savedAt']
  }, [event.id, showModal]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      contentLabel={t('events.modal.exitModal.contentLabel')}
      className='exit-modal'
      autoFocus
    >
      <div id='ExitModal'>
        <div className='d-flex flex-column align-items-center modal-container'>
          <div className='d-flex justify-content-center align-items-center icon-wrapper'>
            <GolferIcon className='golfer-icon' fill='#fff' width={'60px'} height={'60px'}/>
          </div>
          <div className='modal-content'>
            <span className='title'>{t('events.modal.exitModal.title')}</span>
            {scoresSavedAt ? (
              <>
                <p className='mb-3'>{t('events.modal.exitModal.confirmStopLogging')}</p>
                <p>{t('events.modal.exitModal.scoresLastSaved', { time: scoresSavedAt })}</p>
              </>
            ) : (
              <>
                <p className='mb-3'>{t('events.modal.exitModal.confirmStopEditing')}</p>
                { event.students.length > 0 && <p>{t('events.modal.exitModal.scoresNotSaved')}</p> }
              </>
            )}
          </div>
          <div className='w-100 pull-bottom'>
            <SubmitButton
              onClick={closeModal}
              buttonMessage={t('common.flow.continueEditing')}
              buttonColor='orange-button'
            />
            {!scoresSavedAt && event.students.length > 0 &&
              <SubmitButton
                onClick={saveDraftScores}
                buttonMessage={t('events.modal.exitModal.saveAndPublishLater')}
                buttonColor='orange-button'
              />
            }
            <SubmitButton
              onClick={onSubmit}
              buttonMessage={scoresSavedAt ? t('events.modal.exitModal.exitAndPublishLater') : t('events.modal.exitModal.discardChangesAndExit')}
              buttonColor='navy-button'
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

ExitModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saveDraftScores: PropTypes.func.isRequired,
  event: PropTypes.object,
}

export default ExitModal
